export default __webpack_public_path__ + "static/media/NTEX CLASS-8 EXAM PATTERN 2025.062f97f0.pdf";